import { LitElement, html, css, CSSResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import '@refinitiv-ui/elements/icon';
import logoUrl from './../assets/lseg_logo_rgb_pos.png';

@customElement('heimdall-frame')
export class HeimdallFrame extends LitElement {
  render() {
    return html`<ef-layout>
      <ef-layout class="frame">
        <img src=${logoUrl} class="logo" alt="Refinitiv logo" />
        <ef-layout class="content">
          <slot></slot>
        </ef-layout>
        <ef-layout flex container size="30px" class="footer" role="contentinfo">
          <div class="footer-content">
            <a
              href="https://support.lseg.com/s/?productName=Refinitiv%20Workspace&query=I%20cannot%20access%20the%20product"
              target="_blank"
              rel="noopener noreferrer"
              >Contact Us<ef-icon
                icon="external-content"
                aria-hidden="true"
              ></ef-icon
            ></a>
            <span class="separator" aria-hidden="true"></span>
            <a
              href="https://www.lseg.com/en/policies/privacy-statement"
              target="_blank"
              rel="noopener noreferrer"
              >Privacy<ef-icon
                icon="external-content"
                aria-hidden="true"
              ></ef-icon
            ></a>
          </div>
        </ef-layout>
      </ef-layout>
    </ef-layout>`;
  }

  static get styles(): CSSResult {
    return css`
      .frame {
        display: flex;
        flex-direction: column;
        width: min(410px, calc(100vw - 32px));
        min-height: min(583px, calc(100dvh - 32px));
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: none;
        background-color: #fff;
      }

      .logo {
        display: block;
        margin: 40px auto;
        width: 212px;
      }

      .content {
        flex-grow: 1;
        display: block;
        padding: 43px 30px 10px;
        text-align: center;
      }

      .footer {
        width: 100%;
        height: 30px;
        box-sizing: border-box;
        background-color: #001aff;
        font-size: 13px;
      }

      .footer-content {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 22px;
      }

      .footer a {
        display: inline-flex;
        align-items: center;
        color: #fff;
        text-decoration: none;
      }

      .footer a:hover,
      .footer a:focus-visible {
        text-decoration: underline;
      }

      .footer ef-icon {
        width: 12px;
        height: 12px;
        margin-left: 2px;
      }

      .separator {
        width: 1px;
        height: 14px;
        background-color: #fff;
      }

      @media (max-width: 600px), (max-height: 600px) {
        .frame {
          position: static;
          width: 100%;
          min-height: 100dvh;
          transform: none;
        }
      }

      @media (max-height: 600px) {
        .logo {
          margin-block: 24px;
        }

        .content {
          padding-top: 24px;
        }
      }
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-frame': HeimdallFrame;
  }
}
